/* ============================================================
   THE UNCLE GANG™ — SHOPIFY THEME JS
   Features: nav drawer, countdown, popup, scroll reveal,
   search toggle, mobile accordion, cart feedback
============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- MOBILE NAV DRAWER ---- */
  var hamburger     = document.getElementById('hamburgerBtn');
  var mobileNav     = document.getElementById('MobileNav');
  var overlay       = document.getElementById('mobileNavOverlay');
  var closeBtn      = document.getElementById('mobileNavClose');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (hamburger) { hamburger.classList.add('is-open'); hamburger.setAttribute('aria-expanded', 'true'); }
  }

  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (hamburger) { hamburger.classList.remove('is-open'); hamburger.setAttribute('aria-expanded', 'false'); }
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (closeBtn)  closeBtn.addEventListener('click', closeNav);
  if (overlay)   overlay.addEventListener('click', closeNav);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  // Mobile accordion for parent links with children
  var mobileParents = document.querySelectorAll('.mobile-nav-parent');
  mobileParents.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all others
      mobileParents.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var sib = b.nextElementSibling;
        if (sib && sib.classList.contains('mobile-nav-children')) sib.classList.remove('is-open');
      });
      // Toggle this one
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        var children = this.nextElementSibling;
        if (children && children.classList.contains('mobile-nav-children')) children.classList.add('is-open');
      }
    });
  });

  /* ---- SEARCH TOGGLE ---- */
  var searchToggle = document.getElementById('searchToggle');
  var searchBar    = document.getElementById('searchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var hidden = searchBar.hasAttribute('hidden');
      if (hidden) {
        searchBar.removeAttribute('hidden');
        searchBar.querySelector('input').focus();
      } else {
        searchBar.setAttribute('hidden', '');
      }
    });
  }

  /* ---- COUNTDOWN TIMER ---- */
  function updateCountdown() {
    var el = document.getElementById('countdown');
    if (!el) return;
    var now  = new Date();
    var end  = new Date();
    end.setHours(23, 59, 59, 0);
    var diff = end - now;
    if (diff <= 0) { el.textContent = '00:00:00'; return; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  setInterval(updateCountdown, 1000);
  updateCountdown();

  /* ---- SCROLL REVEAL ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10 });
    reveals.forEach(function (el) { revealObserver.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---- EMAIL POPUP ---- */
  var popupShown = false;
  function showPopup() {
    if (!popupShown && !sessionStorage.getItem('ugPopupDismissed')) {
      var popup = document.getElementById('emailPopup');
      if (popup) { popup.classList.add('active'); popupShown = true; }
    }
  }
  setTimeout(showPopup, 6000);

  var popup = document.getElementById('emailPopup');
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === this) closePopup();
    });
  }

  /* ---- SMOOTH SCROLL ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id === '#') return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeNav();
      }
    });
  });

  /* ---- PRODUCT GALLERY THUMBNAILS ---- */
  var thumbs  = document.querySelectorAll('.product-gallery-thumbs img');
  var mainImg = document.getElementById('mainProductImg');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.full || this.src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ---- BUNDLE OPTION SELECTOR ---- */
  var bundleOptions = document.querySelectorAll('.bundle-option');
  bundleOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      bundleOptions.forEach(function (o) { o.classList.remove('selected'); });
      this.classList.add('selected');
    });
  });

  /* ---- STICKY CTA SHOW/HIDE ---- */
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta) {
    window.addEventListener('scroll', function () {
      stickyCta.style.display = window.scrollY > 400 ? 'flex' : 'none';
    }, { passive: true });
  }

  /* ---- ADD TO CART FEEDBACK ---- */
  document.querySelectorAll('.btn-add-to-cart:not(.sold-out)').forEach(function (btn) {
    if (btn.tagName === 'BUTTON') {
      btn.addEventListener('click', function () {
        var orig = this.innerHTML;
        this.innerHTML = '✓ Added!';
        this.style.background = '#27ae60';
        var self = this;
        setTimeout(function () {
          self.innerHTML = orig;
          self.style.background = '';
        }, 2000);
      });
    }
  });

});

/* ---- GLOBAL HELPERS ---- */
function closePopup() {
  var popup = document.getElementById('emailPopup');
  if (popup) popup.classList.remove('active');
  sessionStorage.setItem('ugPopupDismissed', '1');
}

function handlePopupSubmit(e) {
  e.preventDefault();
  var btn = e.target.querySelector('button');
  if (btn) { btn.textContent = '✓ You\'re in!'; btn.style.background = '#27ae60'; }
  setTimeout(closePopup, 1500);
}

function selectBundle(el, qty) {
  document.querySelectorAll('.bundle-option').forEach(function (o) { o.classList.remove('selected'); });
  el.classList.add('selected');
  var qtyInput = document.getElementById('bundleQty');
  if (qtyInput) qtyInput.value = qty;
}
